import { RunRow } from "../services/tradingAgentsV2";

interface RunHistoryProps {
  runs: RunRow[];
  selectedRunId: string | null;
  onSelect: (runId: string) => void;
  isLoading?: boolean;
}

export function RunHistory({
  runs,
  selectedRunId,
  onSelect,
  isLoading,
}: RunHistoryProps) {
  if (isLoading) {
    return <p className="text-sm text-gray-500">Loading runs…</p>;
  }
  if (runs.length === 0) {
    return (
      <p className="text-sm text-gray-500">No runs yet. Start an analysis above.</p>
    );
  }
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200">
      <table className="min-w-full divide-y divide-gray-200 text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-3 py-2 text-left font-medium text-gray-700">
              Ticker
            </th>
            <th className="px-3 py-2 text-left font-medium text-gray-700">
              Date
            </th>
            <th className="px-3 py-2 text-left font-medium text-gray-700">
              Status
            </th>
            <th className="px-3 py-2 text-left font-medium text-gray-700">
              Run ID
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 bg-white">
          {runs.map((r) => (
            <tr
              key={r.run_id}
              onClick={() => onSelect(r.run_id)}
              className={`cursor-pointer hover:bg-primary-50 ${
                selectedRunId === r.run_id ? "bg-primary-50" : ""
              }`}
            >
              <td className="px-3 py-2 font-medium text-gray-900">{r.ticker}</td>
              <td className="px-3 py-2 text-gray-600">{r.trade_date}</td>
              <td className="px-3 py-2 text-gray-600">{r.status}</td>
              <td className="px-3 py-2 font-mono text-xs text-gray-500">
                {r.run_id.slice(0, 8)}…
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
